export default __webpack_public_path__ + "static/media/left_page_icon.b4cb4110.svg";